import { Record, Set } from 'immutable';
import { EventSearchFilter } from './event-filter';

const EventSearchTextRecord = Record({
  searchText: ''
});

export class EventSearchText extends EventSearchTextRecord {
  searchText: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/event-search-text.ts